var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95 10.7L5.575 9.3C5.375 9.1 5.13767 9 4.863 9C4.58767 9 4.35 9.1 4.15 9.3C3.95 9.5 3.846 9.73733 3.838 10.012C3.82933 10.2873 3.925 10.525 4.125 10.725L6.25 12.85C6.45 13.05 6.68333 13.15 6.95 13.15C7.21667 13.15 7.45 13.05 7.65 12.85L11.9 8.6C12.1 8.4 12.2 8.16233 12.2 7.887C12.2 7.61233 12.1 7.375 11.9 7.175C11.7 6.975 11.4627 6.875 11.188 6.875C10.9127 6.875 10.675 6.975 10.475 7.175L6.95 10.7ZM8 19.925H7.75C7.66667 19.925 7.59167 19.9083 7.525 19.875C5.34167 19.1917 3.54167 17.8373 2.125 15.812C0.708333 13.7873 0 11.55 0 9.1V4.375C0 3.95833 0.121 3.58333 0.363 3.25C0.604333 2.91667 0.916667 2.675 1.3 2.525L7.3 0.275002C7.53333 0.191668 7.76667 0.150002 8 0.150002C8.23333 0.150002 8.46667 0.191668 8.7 0.275002L14.7 2.525C15.0833 2.675 15.396 2.91667 15.638 3.25C15.8793 3.58333 16 3.95833 16 4.375V9.1C16 11.55 15.2917 13.7873 13.875 15.812C12.4583 17.8373 10.6583 19.1917 8.475 19.875C8.39167 19.9083 8.23333 19.925 8 19.925V19.925ZM8 17.9C9.73333 17.35 11.1667 16.25 12.3 14.6C13.4333 12.95 14 11.1167 14 9.1V4.375L8 2.125L2 4.375V9.1C2 11.1167 2.56667 12.95 3.7 14.6C4.83333 16.25 6.26667 17.35 8 17.9Z",
    fill: "#000A19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.8892ae86d79357bae7e6cf87afe982ca.svg";
export { ForwardRef as ReactComponent };